import { useEffect, useState } from "react";
import { shellApi } from "../api/shellApi";

export function useTableLayoutPrefs(tableKey: string) {
  const [prefs, setPrefs] = useState<Record<string, unknown>>({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void shellApi
      .getTableLayout(tableKey)
      .then((value) => {
        if (!cancelled) {
          setPrefs(value ?? {});
          setLoaded(true);
        }
      })
      .catch(() => {
        if (!cancelled) setLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, [tableKey]);

  const savePrefs = async (next: Record<string, unknown>, shared?: boolean) => {
    setPrefs(next);
    await shellApi.saveTableLayout(tableKey, next, shared);
  };

  return { prefs, loaded, savePrefs };
}
